import { render, staticRenderFns } from "./IconPadlock.vue?vue&type=template&id=c857b4c4&scoped=true&"
import script from "./IconPadlock.vue?vue&type=script&lang=js&"
export * from "./IconPadlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c857b4c4",
  null
  
)

export default component.exports